import { paymentImportRuns } from '../paymentImportRun'
import { describeTable } from './describeTable'

describeTable(paymentImportRuns, {
  description: `One execution of the automatic bank-payment import from Fennoa (source='fennoa'), daily at 07:00 Helsinki. Holds the same parse and import results the manual KTL upload page shows, so a run can be reviewed afterwards. The payments themselves are in invoice_payments (archive_id 'fennoa:<statement_id>').`,
  columns: {
    source: "Always 'fennoa' today.",
    status: "'running' while in progress, then 'done' or 'failed'.",
    windowFrom: 'First ledger booking date read (inclusive).',
    windowTo: 'Last ledger booking date read (inclusive).',
    latestBookedDate:
      'Newest booking date Fennoa had for the account when the run read it.',
    parseResult: 'JSON: every ledger transaction with its match status.',
    importResult:
      'JSON: counts and the invoices paid, partial, overpaid, already paid, redirected or voided.',
    skipped:
      'JSON: ledger rows ignored by kind (outgoing, otherAccount, noMessage, unknownShape).',
    error: 'Error text when status is failed.',
    triggeredByUserId:
      'Staff member who started the run by hand; null for the schedule.',
  },
})
